/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clear_TimecodesInputs */

const en_clear_timecodes = /** @type {(inputs: Clear_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear Timecodes`)
};

const fr_clear_timecodes = /** @type {(inputs: Clear_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer les codes temporels`)
};

const de_clear_timecodes = /** @type {(inputs: Clear_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitcodes löschen`)
};

const it_clear_timecodes = /** @type {(inputs: Clear_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancella i timecode`)
};

const ru_clear_timecodes = /** @type {(inputs: Clear_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Очистить временные метки`)
};

const es_clear_timecodes = /** @type {(inputs: Clear_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar códigos de tiempo`)
};

const zh_cn2_clear_timecodes = /** @type {(inputs: Clear_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清除时间码`)
};

const ja_clear_timecodes = /** @type {(inputs: Clear_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコードをクリアする`)
};

const hi_clear_timecodes = /** @type {(inputs: Clear_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय कोड साफ़ करें`)
};

const pt_pt2_clear_timecodes = /** @type {(inputs: Clear_TimecodesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limpar códigos de tempo`)
};

/**
* | output |
* | --- |
* | "Clear Timecodes" |
*
* @param {Clear_TimecodesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const clear_timecodes = /** @type {((inputs?: Clear_TimecodesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clear_TimecodesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_clear_timecodes(inputs)
	if (locale === "de") return de_clear_timecodes(inputs)
	if (locale === "it") return it_clear_timecodes(inputs)
	if (locale === "ru") return ru_clear_timecodes(inputs)
	if (locale === "es") return es_clear_timecodes(inputs)
	if (locale === "zh-CN") return zh_cn2_clear_timecodes(inputs)
	if (locale === "ja") return ja_clear_timecodes(inputs)
	if (locale === "hi") return hi_clear_timecodes(inputs)
	if (locale === "pt-PT") return pt_pt2_clear_timecodes(inputs)
	return en_clear_timecodes(inputs)
});